<script lang="ts">
    import { App } from "@/constants";
    import { STATUS } from "@/constants/statuses";
    import RewardsAvailableRewardsListWidget from "@apps/rewards/widgets/rewards_available_rewards_list_widget/RewardsAvailableRewardsListWidget";
    import type ClipboardInterface from "@lib/DOMClipboardAdapter/ClipboardInterface";
    import DOMClipboardAdapter from "@lib/DOMClipboardAdapter/DOMClipboardAdapter";
    import type ModulesStatusesProvider from "@modules/base_module/ModulesStatusesProvider/ModulesStatusesProvider";
    import { MODULE_STATUS } from "@modules/base_module/ModulesStatusesProvider/types";
    import type NudgesEntity from "@modules/nudges/entities/NudgesEntity";
    import type { SelectedDiscountValue } from "@modules/nudges/types";
    import { NUDGES_REWARD_TYPES } from "@modules/nudges/types";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Spinner from "@components/Spinner/Spinner.svelte";
    import Widget from "@components/Widget.svelte";
    import type { LoggerInterface } from "@interfaces/LoggerInterface";

    import { nudgesCustomerRewardsState } from "../state/nudgesCustomerRewardsState";

    export let nudges: NudgesEntity;
    export let modulesStatusesProvider: ModulesStatusesProvider;
    export let logger: LoggerInterface;

    let giftCardButtonText = "Copy";
    const clipboard: ClipboardInterface = new DOMClipboardAdapter();

    const {
        NudgesPopUpWidgetVisibilityManager,
        nudgesService,
        cartStatus$,
        applyDiscount,
        applyDiscountAndAddToCard,
    } = nudgesCustomerRewardsState();

    const rewardsAppStatus$ = modulesStatusesProvider.selectModuleStatus(
        App.Rewards
    );

    $: selectedValue = null as SelectedDiscountValue | null;

    const handleChange = (value: SelectedDiscountValue): void => {
        selectedValue = value;
    };

    const handleAddView = () => {
        if (
            selectedValue &&
            selectedValue.type === NUDGES_REWARD_TYPES.discount
        ) {
            nudgesService.addAction({
                nudgeId: nudges.nudge.id,
            });
            nudgesService.addViewed({
                nudgeId: nudges.nudge.id,
            });
            applyDiscount(selectedValue.code, selectedValue.itemId);

            NudgesPopUpWidgetVisibilityManager.nudgesPopUpWidgetHide();
        } else if (
            selectedValue &&
            selectedValue.type === NUDGES_REWARD_TYPES.freeProduct &&
            selectedValue.variantId
        ) {
            nudgesService.addAction({
                nudgeId: nudges.nudge.id,
            });
            nudgesService.addViewed({
                nudgeId: nudges.nudge.id,
            });
            applyDiscountAndAddToCard(
                selectedValue.variantId,
                selectedValue.code,
                selectedValue.itemId
            );

            NudgesPopUpWidgetVisibilityManager.nudgesPopUpWidgetHide();
        }
    };

    const handleCopy = () => {
        if (selectedValue) {
            clipboard.writeText(selectedValue.code);
            giftCardButtonText = "Copied";

            setTimeout(() => (giftCardButtonText = "Copy"), 1500);
        }
    };
</script>

<div class="gw-nudges-modal__reward-redeem-action-wrapper">
    {#if $rewardsAppStatus$ === MODULE_STATUS.INITIALIZED}
        <Widget
            widget={RewardsAvailableRewardsListWidget}
            params={[
                { onChange: handleChange, locale: nudges.template.locale },
                logger,
            ]}
        />
    {/if}
    {#if selectedValue?.type === NUDGES_REWARD_TYPES.giftCard}
        <BaseButton
            class="gw-nudges-modal__reward-redeem-active-button"
            disabled={selectedValue === null}
            on:click={() => handleCopy()}
        >
            {giftCardButtonText}
        </BaseButton>
    {:else}
        <BaseButton
            on:click={() => handleAddView()}
            class="gw-nudges-modal__reward-redeem-active-button"
            disabled={selectedValue === null}
        >
            {#if $cartStatus$ === STATUS.LOADING}
                <Spinner size="18px" />
            {:else}
                {nudges.template.ctaw.text}
            {/if}
        </BaseButton>
    {/if}
</div>

<style lang="postcss">
    .gw-nudges-modal__reward-redeem-action-wrapper {
        display: flex;
        margin-top: var(--gw-ng-space-5);
    }

    @media all and (max-width: 500px) {
        .gw-nudges-modal__reward-redeem-action-wrapper {
            flex-direction: column;
        }
    }
</style>
